import { z } from 'zod';

export const searchSchema = z.object({
  // Basic fields
  ngay_ct1: z.string().min(1, 'Ngày từ không được để trống'),
  ngay_ct2: z.string().min(1, 'Ngày đến không được để trống'),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),

  ma_lvt: z.string().optional(),
  ton_kho_yn: z.boolean().optional(),
  mau_bc: z.string().optional(),

  // Other tab
  group_by: z.string().optional(),
  dien_giai: z.string().optional(),
  reportFilterTemplate: z.string().optional(),
  data_analysis_struct: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  ma_lvt: '',
  group_by: '1',
  ton_kho_yn: true,
  mau_bc: '20',
  dien_giai: ''
};
